// Espelha src/server/shared/services/FeriadosBrasil.ts do backend — usado só pra prévia
// (mostrar ao usuário, antes de gerar, qual vai ser o vencimento real de cada parcela,
// já com o ajuste de fim de semana/feriado que o backend também aplica).

const chave = (data: Date): string => `${data.getFullYear()}-${data.getMonth()}-${data.getDate()}`;

const somarDias = (data: Date, dias: number): Date =>
  new Date(data.getFullYear(), data.getMonth(), data.getDate() + dias);

const calcularPascoa = (ano: number): Date => {
  const a = ano % 19;
  const b = Math.floor(ano / 100);
  const c = ano % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(ano, mes - 1, dia);
};

const feriadosNacionais = (ano: number): Set<string> => {
  const pascoa = calcularPascoa(ano);
  const datas = [
    new Date(ano, 0, 1),
    somarDias(pascoa, -48),
    somarDias(pascoa, -47),
    somarDias(pascoa, -2),
    new Date(ano, 3, 21),
    new Date(ano, 4, 1),
    somarDias(pascoa, 60),
    new Date(ano, 8, 7),
    new Date(ano, 9, 12),
    new Date(ano, 10, 2),
    new Date(ano, 10, 15),
    new Date(ano, 11, 25),
  ];
  return new Set(datas.map(chave));
};

const ehFimDeSemana = (data: Date): boolean => {
  const diaSemana = data.getDay();
  return diaSemana === 0 || diaSemana === 6;
};

const ehFeriado = (data: Date): boolean => feriadosNacionais(data.getFullYear()).has(chave(data));

export const proximoDiaUtil = (data: Date): Date => {
  let atual = data;
  while (ehFimDeSemana(atual) || ehFeriado(atual)) {
    atual = somarDias(atual, 1);
  }
  return atual;
};
